<template>
	<div>
		<div class="form-group row ">
			<div class="col-9">
				<input type="text" placeholder="Question" class="form-control wide-modal--input wide-modal--input-remove-min-width" v-model="question">
			</div>
			<div class="col-3">
				<select @change="clearOptions()" class="form-control wide-modal--input wide-modal--input-remove-min-width" v-model="type">
					<option value="date">Date and Time </option>
					<option value="free_text">Free Text</option>
					<option value="dropdown">Single choice</option>
					<option v-if="type === 'checkbox_other'" value="checkbox_other">Multiple choice</option>
					<option v-else value="checkbox">Multiple choice</option>
				</select>
			</div>
		</div>
		<!--Dropdown-->
        <div class="form-group row" v-if="type === 'dropdown' || type === 'dropdown_other'">
            <div class="col-12">
				<label>Answer</label>
                <div class="d-flex mb-2" v-for="(option, index) in options">
                    <input class="col-9 form-control  wide-modal--input" type="text" v-model="option.label">
                    <select class="col-2 ml-2 form-control wide-modal--input" v-model="option.effect">
                        <option value="fail">Fail</option>
                        <option value="pass">Pass</option>
                        <option value="no_rule">No Rule</option>
                    </select>
                    <a href="javascript:void(0)" class="col-1 d-flex my-auto">
                        <img :src="'/svg/' + resource_group + '/bin.svg'" v-on:click="deleteOptions(index)" class="ml-2 my-auto" alt="">
                    </a>
                </div>
                <div>
					<a href="javascript:void(0)" v-on:click="addOption">
						<svg-image
							:src="'/svg/' + resource_group + '/add_icon.svg'"
							class="d-inline-flex mr-2"
							color="#007FFF">
						</svg-image>Add Answer
					</a>
                </div>
            </div>
        </div>

		<!--Checkbox-->
        <div class="form-group row" v-if="type === 'checkbox' || type === 'checkbox_other'">
				<div class="col-12">
					<label>Answer</label>
					<div class="d-flex mb-2" v-for="(option, index) in options">
						<input class="col-9 form-control wide-modal--input" type="text" v-model="option.label">
						<select class="col-2 ml-2 form-control wide-modal--input" v-model="option.effect">
							<option value="fail">Fail</option>
							<option value="pass">Pass</option>
							<option value="no_rule">No Rule</option>
						</select>
						<a href="javascript:void(0)" class="col-1 d-flex my-auto">
							<img :src="'/svg/' + resource_group + '/bin.svg'" v-on:click="deleteOptions(index)" class="ml-2 my-auto" alt="">
						</a>
					</div>
                <div>
					<a href="javascript:void(0)" v-on:click="addOption">
						<svg-image
							:src="'/svg/' + resource_group + '/add_icon.svg'"
							class="d-inline-flex mr-2"
							color="#007FFF">
						</svg-image>Add Answer
					</a>
                </div>
            </div>
        </div>
			<div class="form-group row">
				<div class="col-12 d-flex flex-wrap">
					<label v-if="type === 'checkbox' || type === 'checkbox_other'" class="checkbox  wide-modal--input-options wide-modal--input-block  d-flex" for="question_other">
						<input type="checkbox" v-model="settings.checkbox_other" id="question_other">
						<div class="checkbox--check my-auto mr-2"></div>
						<span>Include 'Other' option</span>
					</label>
					<!-- <label class="checkbox  wide-modal--input-options  wide-modal--input-block d-flex" for="question_must_be_answered">
						<input type="checkbox" v-model="settings.required" id="question_must_be_answered">
						<div class="checkbox--check my-auto mr-2"></div>
						<span>Question must be answered</span>
					</label> -->
					<label class="checkbox  wide-modal--input-options  wide-modal--input-block d-flex" for="provide_image">
						<input type="checkbox" v-model="settings.provide_image" id="provide_image">
						<div class="checkbox--check my-auto mr-2"></div>
						<span>Provide Image</span>
					</label>
					<label class="checkbox  wide-modal--input-options  wide-modal--input-block d-flex" for="providing_image_mandatory">
						<input :disabled="!settings.provide_image" type="checkbox" :checked="!settings.providing_image_optional" @change="settings.providing_image_optional = !$event.target.checked" id="providing_image_mandatory">
						<div class="checkbox--check my-auto mr-2"></div>
						<span :class="{'wide-modal--disable-text': !settings.provide_image}">Providing image is mandatory</span>
					</label>
					<label class="checkbox  wide-modal--input-options wide-modal--input-block d-flex" for="provide_comment">
						<input type="checkbox" v-model="settings.provide_comment" id="provide_comment">
						<div class="checkbox--check my-auto mr-2"></div>
						<span>Provide comment</span>
					</label>
					<label class="checkbox  wide-modal--input-options wide-modal--input-block d-flex" for="providing_comment_mandatory">
						<input :disabled="!settings.provide_comment" type="checkbox" :checked="!settings.providing_comment_optional" @change="settings.providing_comment_optional = !$event.target.checked" id="providing_comment_mandatory">
						<div class="checkbox--check my-auto mr-2"></div>
						<span :class="{'wide-modal--disable-text': !settings.provide_comment}">Providing comment is mandatory</span>
					</label>
				</div>
			</div>
    </div>
</template>

<script>
	export default {
		name: "AddQuestionForm",
        props: [
            'prefix_key',
            'questionData',
            'index',
        ],
        data (){
			return {
				key            : 0,
                type           : 'free_text',
				question       : '',
				change_other   : true,
				settings       : {
					providing_comment_optional : false,
					providing_image_optional   : false,
					provide_comment            : true,
					provide_image              : true,
					checkbox_other             : false,
					required                   : true,
				},
                options: [
                    {
                    	label  : '',
                        effect : 'pass'
                    }
                ]
            }
        },

        mounted(){
            this.key = this.prefix_key + 1 || 0;
            this.$parent.$on('close-modal', this.reset);
        },

        methods: {
			clearOptions(){
				if(this.type==='free_text'){
					this.options = [
						{
							label: '',
							effect: 'pass',
						}
					];
				}
			},
			save(){
				this.$emit('createOrSaveQuestion', {
                    type: this.type,
                    question: this.question,
                    options: this.options,
					settings:this.settings,
                    key: this.key ++,
                    index: this.index
                });
				// this.reset();
				this.$parent.$emit('close-modal-child');
            },

			addOption(){
				this.options.push({ label: '', effect: 'pass' });
            },

            deleteOptions(index){
			    this.options.splice(index, 1);
            },

            reset(){
                this.type           = 'free_text'
				this.question       = '',
				this.change_other   = true,
				this.settings       = {
					providing_comment_optional : false,
					providing_image_optional   : false,
					provide_comment            : true,
					provide_image              : true,
					checkbox_other             : false,
					required                   : true,
				}
                this.options =  [
                    {
                    	label  : '',
                        effect : 'pass'
                    }
                ]
            }
        },

        watch: {
		    questionData(){
                if(this.questionData){
                    this.question = this.questionData.question;
                    this.options = [...this.questionData.options];
					this.settings = this.questionData.settings
                    this.type = this.questionData.type;
                    this.key = this.questionData.key;

                    if (this.type === 'checkbox_other')
                    	this.settings.checkbox_other = true;

                }
			},
			'settings.checkbox_other'(){
		    	if (!this.change_other){
		    		this.change_other = true;
		    		return;
				}

		    	if (this.settings.checkbox_other)
		    		this.type = 'checkbox_other';
		    	else
		    		this.type = 'checkbox';
			},
			type(){
		    	if (this.type !== 'checkbox' && this.type !== 'checkbox_other'){
					this.change_other = false;
					this.settings.checkbox_other = false;
				}
			}
        }
	}
</script>
